import API          from '../../../../common/http/api.fetch';
import {success, responseMessage, error}
                    from '../../../../common/utils/util.notifier';
import { TYPES }    from '../audit-action-type.constants';
import { IDS }      from '../audit-action-id.constants';
import pick         from 'lodash/pick';
import get          from 'lodash/get';
import {GRID_FETCH} from "../../../../common/grid/grid.constants";

export const resetFields = () => {
    return dispatch => {
        dispatch({
            type:   TYPES.RESET_ADD_AUDIT_FIELDS,
            id:     IDS.addAudit,
        })
        dispatch({
            type: GRID_FETCH,
            id: IDS.accAudit,
            path: IDS.addAuditRequirementsGrid,
            items: []
        });
    };
}

export const resetAssignees = () => {
    return dispatch => {
        dispatch({
            type:   TYPES.RESET_ADD_AUDIT_ASSIGNEES,
            id:     IDS.addAudit,
        })
    };
}

export const scheduleRequirementAudits = (requirements, slo_uuid, year, auditors, evidence_owner) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/add-requirement-audits`,
            method: 'POST',
            data: {
                requirements,
                slo_uuid,
                year,
                auditors,
                evidence_owner,
            }
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_CREATED');
        }, errorResponse => {
            if(errorResponse.data?.message_id === 21) {
                error('ACCREDITATION.AUDIT.ADD.AUDIT_EXISTS_FOR_SECTION', 6);
            }
            else
                responseMessage(errorResponse);
        });
    };
};

export const addEvidenceProvider = (item) => {
    return dispatch => {
        return dispatch({
            type: TYPES.ADD_AUDIT_ASSIGNEE,
            id: IDS.accAudit,
            path: 'details.evidenceProvider',
            item
        });
    };
};

export const verifyAuditExistsForRequirement = (ase_id, slo_uuid, year) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/verify-audit-exists-for-requirement`,
            method: 'GET',
            params: {
                ase_id,
                slo_uuid,
                year,
            }
        }).then(({data}) => {
            if(data.params.audit_already_exists) {
                error('ACCREDITATION.AUDIT.ADD.AUDIT_EXISTS_FOR_SECTION', 6);
            }
            return data.params.audit_already_exists;
        }, errorResponse => {
            responseMessage(errorResponse);
        });
    };
}
